import {inject, injectable} from "inversify";
import {EventEmitter} from "@/modules/base/events";
import {EvaluateDayEvent} from "@/modules/season/events/EvaluateDayEvent";
import {Season} from "@/modules/season/entity";
import {AfterDayEvaluationEvent} from "@/modules/season/events/AfterDayEvaluationEvent";
import type {Ref} from "vue";
import {BeforeDayEvaluationEvent} from "@/modules/season/events/BeforeDayEvaluationEvent";

@injectable()
export class DayEvaluator {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    public isEvaluating: Ref<boolean> = ref(false),
    public isCalculating: Ref<boolean> = ref(false),
  ) {}

  public async evaluate(): Promise<void> {
    console.time('DayEvaluator::evaluate');

    this.isCalculating.value = true;
    const season = await Season.current();

    await this.em.emitAsync(new BeforeDayEvaluationEvent(season));

    await this.em.emitAsync(new EvaluateDayEvent(season));
    season.incrementDay();
    await season.save();
    await this.em.emitAsync(new AfterDayEvaluationEvent(season));

    this.isCalculating.value = false;

    console.timeEnd('DayEvaluator::evaluate');
  }
}